export default __webpack_public_path__ + "static/media/ps5.24f8e291.svg";